<template>
  <v-card>
    <v-card-title>
      <div class="headline font-weight-medium">Імпорт блоків</div>
    </v-card-title>
    <v-card-text>
      <v-stepper v-model="stepper">
        <v-stepper-header>
          <template v-for="step in steps">
            <v-stepper-step :key="`${step.value}-step`" :step="step.value">
              {{ step.title }}
            </v-stepper-step>
            <v-divider
              v-if="step.value !== steps.length"
              :key="step.value"
            ></v-divider>
          </template>
        </v-stepper-header>
        <v-progress-linear v-if="loading" indeterminate class="mb-0" />
        <v-stepper-items>
          <v-stepper-content step="1">
            <v-card>
              <div class="v-toolbar__title">
                Завантаження вмісту з файлу .docx
              </div>
              <div class="py-3">
                <label for="files"
                  ><div
                    :class="[
                      'primary-button',
                      'v-btn',
                      'v-btn--contained',
                      'theme--light',
                      'v-size--default',
                      'cursor-pointer',
                      content ? 'v-btn--disabled' : '',
                    ]"
                  >
                    Завантажити файл
                  </div>
                </label>
                <input
                  id="files"
                  type="file"
                  accept=".docx"
                  :disabled="!!content"
                  class="hidden-element"
                  @input="handleFileUpload"
                />
              </div>
            </v-card>
          </v-stepper-content>
          <v-stepper-content step="2">
            <v-card>
              <v-card-title class="pa-0 pb-4">
                <div class="v-toolbar__title">
                  Створення блоків за даними файлу
                </div>
              </v-card-title>
              <v-card-text class="pa-0 pb-2">
                <SelectTags
                  v-model="tags"
                  :add-btn="true"
                  :multiple-select="true"
                  class="mb-3"
                  @add="addTags"
                />
                <Markdown v-model="content"></Markdown>
              </v-card-text>
              <v-card-actions class="pa-0 pb-2">
                <PrimaryBtn
                  :loading="loading"
                  :disabled="!content"
                  text="Зберегти блок"
                  @click="save"
                />
                <v-spacer />
                <DefaultBtn
                  title="До завантаження файлу"
                  leftSideIcon="mdi-arrow-left-thin"
                  @click="toUploadStep"
                />
                <DefaultBtn
                  title="До формування документу"
                  rightSideIcon="mdi-arrow-right-thin"
                  :disabled="!isSavedBlock"
                  color="primary"
                  class="py-2"
                  @click="toCreateDocStep"
                />
              </v-card-actions>
            </v-card>
          </v-stepper-content>
          <v-stepper-content step="3">
            <v-card>
              <v-card-title class="pa-0 pb-4">
                <v-col>
                  <div class="v-toolbar__title pb-4">
                    Формування документу із блоків в розробці
                  </div>
                  <DefaultBtn
                    title="До завантаження файлу"
                    leftSideIcon="mdi-arrow-left-thin"
                    class="py-2"
                    @click="toUploadStep"
                  />
                </v-col>
              </v-card-title>
            </v-card>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-card-text>
  </v-card>
</template>

<script>
import AddButton from "../../components/AddButton.vue";
import Markdown from "../../components/markdown/Markdown.vue";
import PrimaryBtn from "../../components/PrimaryBtn.vue";
import SelectTags from "../tags/SelectTags.vue";
import DefaultBtn from "../../components/DefaultBtn.vue";
import upload from "../../helpers/uploadFile.js";
import * as uploadFile from "../../backend/pandocWebApi.js";
import { createDocumentBlock } from "../../backend/document-blocksApi.js";

export default {
  components: {
    AddButton,
    Markdown,
    PrimaryBtn,
    SelectTags,
    DefaultBtn,
  },
  data: () => ({
    content: "",
    tags: [],
    loading: false,
    isSavedBlock: false,
    stepper: 1,
    steps: [
      { value: 1, title: "Завантаження файлу" },
      { value: 2, title: "Створення блоків" },
      { value: 3, title: "Формування документу" },
    ],
  }),
  methods: {
    async handleFileUpload(event) {
      this.loading = true;
      const formData = upload(event);
      if (!formData) {
        this.loading = false;
        return;
      }

      try {
        const params = await uploadFile.uploadFile(formData);
        this.content = await uploadFile.getFile(params);
        await uploadFile.deleteFile(params);

        this.stepper = this.steps[1].value;

        const inputFile = document.getElementById("files");
        inputFile.addEventListener(
          "click",
          () => {
            inputFile.value = "";
          },
          false
        );
      } catch {
        this.$notifyWarning("Під час завантаження сталася помилка");
      } finally {
        this.loading = false;
      }
    },
    addTags(values) {
      this.tags = [...this.tags, ...values];
      this.tags = this.tags.filter(
        (v, i, a) => a.findIndex((t) => t.id === v.id) === i
      );
    },
    async save() {
      this.loading = true;
      const block = {
        content: this.content,
        tags: [...new Set(this.tags.map((t) => t.id))],
      };
      try {
        await createDocumentBlock(block);
        this.isSavedBlock = true;
        this.$notifySuccess();
      } catch {
        this.$notifyWarning();
      } finally {
        this.loading = false;
      }
    },
    toUploadStep() {
      this.content = "";
      this.tags = [];
      this.isSavedBlock = false;
      this.stepper = this.steps[0].value;
    },
    toCreateDocStep() {
      this.stepper = this.steps[2].value;
    },
  },
};
</script>
<style>
.hidden-element {
  visibility: hidden;
  position: absolute;
}
</style>
